(function () {
  if (window.__feteWishlistInit) return;
  window.__feteWishlistInit = true;

  // Hoisted (rather than living inside the SwymCallbacks closure below)
  // so shopify:section:load can call revealAll() again later, after
  // Swym has already reported ready once.
  var saved = {};
  var ready = false;

  function paint(btn) {
    var on = !!saved[btn.dataset.empi];
    var title = btn.dataset.productTitle || '';
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('fete-wishlist--on', on);
    btn.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + title + (on ? ' from wishlist' : ' to wishlist'));
  }

  function revealAll() {
    if (!ready) return; // Swym hasn't reported ready yet; nothing to reveal
    document.querySelectorAll('[data-fete-wishlist]').forEach(function (btn) {
      btn.hidden = false;
      paint(btn);
    });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    // Mark already-saved products, then reveal the hearts.
    if (typeof swat.fetchWishlist === 'function') {
      swat.fetchWishlist(function (items) {
        (items || []).forEach(function (item) { saved[item.empi] = true; });
        ready = true;
        revealAll();
      });
    } else {
      ready = true;
      revealAll(); // add-only mode if fetch is unavailable
    }

    // One delegated listener covers every card, including any added later.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fete-wishlist]');
      if (!btn) return;
      e.preventDefault();
      var p = {
        epi: Number(btn.dataset.epi),
        empi: Number(btn.dataset.empi),
        du: btn.dataset.du,
      };
      if (saved[p.empi] && typeof swat.removeFromWishList === 'function') {
        swat.removeFromWishList(p, function () { saved[p.empi] = false; paint(btn); });
      } else if (typeof swat.addToWishList === 'function') {
        swat.addToWishList(p, function () { saved[p.empi] = true; paint(btn); });
      }
    });
  });

  document.addEventListener('shopify:section:load', revealAll);
})();
